import { Link } from "react-router-dom";
import ServiesData from '../../../data/ServiesData.json';
import { useTranslation } from 'react-i18next';


export default function ServiesLinks() {
    const { i18n } = useTranslation();
    return (
        <ul className='d-none d-lg-block col-5 col-lg-3'>
            {ServiesData.map((service, index) => (
                <li key={index} className='footer-links'>
                    <Link to={"/" + i18n.language + service.link} className='nav-link p-1' aria-current="page" >
                        {i18n.language === 'en' ? service.titleEn : service.title}
                        {/* {service.title} */}
                    </Link>
                </li>
            ))}
        </ul>
    )
};
